import type { AppMode } from '@common/types/config/AppMode'
import theme from './theme.scss'

export function modeTheme(mode: AppMode): string {
	return theme[mode.replaceAll(/-([a-z])/g, (_, x) => x.toUpperCase())]
}

export function bikeColor(type: 'bike' | 'bss'): string {
	return (type === 'bike' ? theme.bike : theme.bss) ?? theme.bike ?? ''
}

// eslint-disable-next-line unicorn/prefer-export-from
export default theme
